import React, { useState, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';

import Recipe from '../../recipe/api';
import { RECIPE_LIST } from '../../constants/recipe';
import { RecipeItem } from './RecipeItem';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  labelRoot: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9em',
    },
  },
}));

export default function RecipeList({
  daysValue,
  duplicated,
  handleDuplicatedOption,
  label,
  categoryId,
  onClickCheckbox,
  ...props
}) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  return (
    <List component="nav" aria-labelledby="nested-list-subheader" className={classes.root}>
      {RECIPE_LIST.map(({ label, categoryId }, i) => (
        <RecipeItem key={i} label={label} categoryId={categoryId} onClickCheckbox={onClickCheckbox} />
      ))}
    </List>
  );
}
